<script>

    import { toast } from 'bulma-toast'

    import TilService from '../$services/til.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import StatsCard from '../$components/stats.card.svelte'
    import Spinner from '../$components/spinner.svelte'

    export let dateStart = null
    export let dateEnd = null

    let loading = false
    let stats = null

    $: if (dateStart && dateEnd)
        getTrackings()

    async function getTrackings() {
        loading = true
        stats = null

        const resp = await TilService.getTrackingsTil({ dateStart, dateEnd })

        loading = false

        if (!resp.success)
            return toast({ message: resp.error.message, type: 'is-danger' })

        stats = resp.data
    }

</script>

<style>
    .stats-grid :global(.stats-card) {
        height: 100%;
    }

    .drivers-list {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 100%;
    }

    .drivers-list__item {
        display: flex;
        align-items: flex-start;
        gap: 0.75rem;
        padding: 0.85rem 0;
        border-bottom: 1px solid #eee;
    }

    .drivers-list__item:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }

    .drivers-list__item:first-child {
        padding-top: 0;
    }

    .drivers-list__rank {
        flex-shrink: 0;
        width: 1.75rem;
        height: 1.75rem;
        margin-top: 0.1rem;
        border-radius: 50%;
        background: #f4f4f4;
        color: #666;
        font-size: 12px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .drivers-list__info {
        flex: 1;
        min-width: 0;
    }

    .drivers-list__title {
        font-size: 14px;
        font-weight: 600;
        color: #1a1a1a;
        margin: 0 0 2px;
    }

    .drivers-list__meta {
        font-size: 12px;
        color: #a0a0a0;
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .drivers-list__total {
        flex-shrink: 0;
        font-size: 15px;
        font-weight: 700;
        color: var(--color-primary, #098E37);
        text-align: right;
    }

    .status-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 0.35rem;
        margin-top: 0.45rem;
    }

    .status-tags--summary {
        margin: 0 0 1.25rem;
    }

    .status-tag {
        display: inline-flex;
        align-items: center;
        gap: 0.35rem;
        background: #f4f4f4;
        color: #3a3a3a;
        border-radius: 999px;
        padding: 0.2rem 0.6rem;
        font-size: 12px;
        font-weight: 600;
        line-height: 1.3;
    }

    .status-tag strong {
        color: var(--color-primary, #098E37);
    }
</style>

<div class="columns is-multiline is-mobile is-variable is-5 stats-grid mb-5">
    <div class="column is-full-mobile is-one-third-tablet">
        <StatsCard icon="fa-barcode" meta="Escaneos" title="Escaneos" {dateStart} {dateEnd}>
            <div>
                <Spinner {loading} />
                {#if !loading && stats}
                    <p class="value">{ NumeralMethods.number(stats.scans) }</p>
                    <p class="location">Registros de tracking en el periodo</p>
                {/if}
            </div>
        </StatsCard>
    </div>
    <div class="column is-full-mobile is-one-third-tablet">
        <StatsCard icon="fa-box" meta="Paquetes" title="Paquetes" {dateStart} {dateEnd}>
            <div>
                <Spinner {loading} />
                {#if !loading && stats}
                    <p class="value">{ NumeralMethods.number(stats.packages) }</p>
                    <p class="location">Guías distintas escaneadas</p>
                {/if}
            </div>
        </StatsCard>
    </div>
    <div class="column is-full-mobile is-one-third-tablet">
        <StatsCard icon="fa-id-badge" meta="Drivers" title="Drivers" {dateStart} {dateEnd}>
            <div>
                <Spinner {loading} />
                {#if !loading && stats}
                    <p class="value">{ NumeralMethods.number(stats.driversCount) }</p>
                    <p class="location">Drivers con escaneos</p>
                {/if}
            </div>
        </StatsCard>
    </div>
</div>

{#if !loading && stats && stats.statuses && stats.statuses.length}
    <div class="status-tags status-tags--summary">
        {#each stats.statuses as status}
            <span class="status-tag">{ status.name } <strong>{ NumeralMethods.number(status.packages) }</strong></span>
        {/each}
    </div>
{/if}

<StatsCard icon="fa-users" meta="Drivers" title="Paquetes por driver" {dateStart} {dateEnd}>
    <div>
        <Spinner {loading} />
        {#if !loading && stats && stats.drivers.length}
            <ul class="drivers-list">
                {#each stats.drivers as driver, index}
                    <li class="drivers-list__item">
                        <span class="drivers-list__rank">{ index + 1 }</span>
                        <div class="drivers-list__info">
                            <p class="drivers-list__title">{ driver.name || 'Sin nombre' }</p>
                            <p class="drivers-list__meta">{ driver.email || '' }</p>
                            {#if driver.statuses && driver.statuses.length}
                                <div class="status-tags">
                                    {#each driver.statuses as status}
                                        <span class="status-tag">{ status.name } <strong>{ NumeralMethods.number(status.packages) }</strong></span>
                                    {/each}
                                </div>
                            {/if}
                        </div>
                        <span class="drivers-list__total">
                            { NumeralMethods.number(driver.scans) } escaneos
                            <br />
                            { NumeralMethods.number(driver.packages) } paquetes
                        </span>
                    </li>
                {/each}
            </ul>
        {:else if !loading}
            <p class="empty">Sin escaneos en el periodo seleccionado</p>
        {/if}
    </div>
</StatsCard>
